module.exports = __webpack_public_path__ + "img/task-centre.2b2b643a.svg";